import { consoleEvents } from '@pb/utils'

import { initAdyenCheckout, completeAdyenCheckout } from 'features/adyen/duck/actions'
import { getAdyenAction } from 'features/adyen/duck/selectors'
import { CheckoutSuccessAction } from 'features/checkout/constants'
import { postProceedFail } from 'features/checkout/duck/actions'
import { handleProceedError } from 'features/checkout/duck/operations/postProceed/handleProceedError'
import { postConfirmCheckout } from 'features/checkout/requests'
import { ThunkResult } from 'redux/types'

export const operationConfirmAdyenCheckout =
  ({ paymentData, ...details }): ThunkResult<Promise<void>> =>
  async (dispatch) => {
    try {
      dispatch(completeAdyenCheckout())
      const confirmResponse = await postConfirmCheckout({
        details,
        paymentData,
      })

      if (confirmResponse.successAction === CheckoutSuccessAction.AdyenChallenge) {
        const {
          pageAttributes: { action, ...config },
        } = confirmResponse
        dispatch(initAdyenCheckout({ action: JSON.parse(action), config }))
      } else if (confirmResponse.successAction === CheckoutSuccessAction.SelfRedirect) {
        window.location.href = confirmResponse.redirectURL
      }
    } catch (error) {
      consoleEvents.error('Failed to confirm checkout', error)
      dispatch(postProceedFail())
      dispatch(handleProceedError(error))
    }
  }

export const operationAbortConfirmAdyenCheckout =
  (): ThunkResult<Promise<void>> => async (dispatch, getState) => {
    try {
      const state = getState()
      const { paymentData } = getAdyenAction(state)
      dispatch(completeAdyenCheckout())
      await postConfirmCheckout({
        paymentData,
        abortPayment: true,
      })
    } catch (error) {
      consoleEvents.error('Failed to confirm checkout', error)
      dispatch(postProceedFail())
      dispatch(handleProceedError(error))
    }
  }
